// From https://sites.google.com/site/gmapsdevelopment/

export const LocationPinImages = Object.freeze({
    red: 'http://maps.google.com/mapfiles/ms/icons/red.png',
    redDot: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
    purple: 'http://maps.google.com/mapfiles/ms/icons/purple.png',
    purpleDot: 'http://maps.google.com/mapfiles/ms/icons/purple-dot.png',
    blue: 'http://maps.google.com/mapfiles/ms/icons/blue.png',
    blueDot: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
    lightblue: 'http://maps.google.com/mapfiles/ms/icons/lightblue.png',
    lightblueDot: 'http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png',
    orange: 'http://maps.google.com/mapfiles/ms/icons/orange.png',
    orangeDot: 'http://maps.google.com/mapfiles/ms/icons/orange-dot.png',
    cyan: 'http://maps.google.com/mapfiles/ms2/micons/ltblue.png',
    cyanDot: 'http://maps.google.com/mapfiles/ms2/micons/ltblue-dot.png',
    yellow: 'http://maps.google.com/mapfiles/ms/icons/yellow.png',
    yellowDot: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
    green: 'http://maps.google.com/mapfiles/ms/icons/green.png',
    greenDot: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
    pink: 'http://maps.google.com/mapfiles/ms/icons/pink.png',
    pinkDot: 'http://maps.google.com/mapfiles/ms/icons/pink-dot.png',
    home: 'http://maps.google.com/mapfiles/kml/pal3/icon56.png',
    building: 'http://maps.google.com/mapfiles/kml/pal3/icon21.png',
    man: 'http://maps.google.com/mapfiles/ms/micons/man.png',
    flag: 'http://maps.google.com/mapfiles/ms/icons/lightblue.png',
    mask: 'http://maps.google.com/mapfiles/ms/micons/arts.png',
    cinema: 'http://maps.google.com/mapfiles/kml/pal2/icon14.png'
  });

export const LocationsPinImagesForApps = Object.freeze({
  community: LocationPinImages.redDot,
  communities: LocationPinImages.redDot,
  organization: LocationPinImages.purpleDot,
  organizations: LocationPinImages.purpleDot,
  society: LocationPinImages.purple,
  societies: LocationPinImages.purple,
  member: LocationPinImages.lightblueDot,
  members: LocationPinImages.lightblueDot,
  contact: LocationPinImages.lightblue,
  contacts: LocationPinImages.lightblue,
  event: LocationPinImages.orangeDot,
  events: LocationPinImages.orangeDot,
  challenge: LocationPinImages.yellowDot,
  challenges: LocationPinImages.yellowDot,
  room: LocationPinImages.blueDot,
  rooms: LocationPinImages.blueDot,
  service: LocationPinImages.blueDot,
  services: LocationPinImages.blueDot,
  product: LocationPinImages.blueDot,
  products: LocationPinImages.blueDot,
});

export const AppsWithPins = Object.freeze([
  'communities', 
  'organizations', 
  'societies', 
  'members', 
  'contacts', 
  'events', 
  'challenges', 
  'rooms', 
  'services', 
  'products',
]);

export default LocationPinImages;